import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back\">\n<path d=\"M13.3333 7.33335H5.21996L8.94663 3.60669L7.99996 2.66669L2.66663 8.00002L7.99996 13.3334L8.93996 12.3934L5.21996 8.66669H13.3333V7.33335Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol